import React from "react";
import "../css/runningText.scss";

const Strip = (index) => {
  return (
    <p className="running-text" key={index}>
      <span>BFCM</span>
      <img src={process.env.PUBLIC_URL + "/assets/strip.png"} alt="strip" width="482" height="48" />
    </p>
  );
};

const RunningText = () => {
  let strip = [];

  for (let index = 0; index < 10; index++) {
    strip.push(<Strip key={index} />);
  }

  return (
    <section id="running-text">
      <div className="running-text-wrap">
        <div className="running-text-container">{strip}</div>
      </div>
    </section>
  );
};

export default RunningText;
